<template>
  <Card class="merchant-detail">
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/merchant/list">资金商管理</BreadcrumbItem>
        <BreadcrumbItem>查看</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <template slot="extra">
      <Button type="primary" @click="serviceArea">服务范围</Button>
      <Button type="primary" icon="ios-undo" @click="back">返回</Button>
    </template>
    <div>
      <Form>
        <h4>基本信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="类型">
              <p>{{ shopInfo.stype == 0 ? "资金商" : "服务商" }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem v-if="shopInfo.groupCode" label="经销商分组">
              <p>{{ shopInfo.groupCode }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="主体信息">
              <p>{{ shopInfo.businessInfo }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="渠道编码">
              <p>{{ shopInfo.channelCode }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="营业执照名称">
              <p>{{ shopInfo.lecienceName }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="营业执照号">
              <p>{{ shopInfo.lecienceCode }}</p>
            </FormItem>
          </Col>
        </Row>
        <Divider :dashed="true"></Divider>
        <h4>服务商信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="服务商等级">
              <p>
                {{ shopInfo.dealerLevel == 1 ? "一级服务商" : "二级服务商" }}
              </p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="服务商名称">
              <p>{{ shopInfo.name }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="父级服务商">
              <p>{{ shopInfo.parentCode }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="达能经销商编码">
              <p>{{ shopInfo.elnDealerCode }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="达能经销商名称">
              <p>{{ shopInfo.elnDealerName }}</p>
            </FormItem>
          </Col>
        </Row>
        <Divider :dashed="true"></Divider>
        <h4>联系信息</h4>
        <Row>
          <Col span="8">
            <FormItem label="联系人">
              <p>{{ shopInfo.contacTperson }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="电话">
              <p>{{ shopInfo.contactMobile }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="省市级：">
              <p>{{ shopInfo.provinceName }}/{{ shopInfo.cityName }}</p>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="详细地址">
              <p>{{ shopInfo.addr }}</p>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="备注">
              <p>{{ shopInfo.remark }}</p>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
  </Card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      params: {},
    };
  },
  computed: {
    ...mapGetters({
      shopInfo: "merchant/getShopInfoQuery",
    }),
  },
  created() {
    this.getDetail();
  },
  mounted() {
    console.log(this.shopInfo);
  },
  methods: {
    getDetail() {
      this.$store
        .dispatch("merchant/shopInfoQuery", {
          code: this.$route.query.code,
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    serviceArea() {
      this.$router.push({
        path: "area",
        query: {
          code: this.$route.query.code,
        },
      });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style>
.merchant-detail .ivu-card-head {
  line-height: 2;
}
</style>


// WEBPACK FOOTER //
// src/views/merchant/manage/detail.vue